<template>
  <div class="margin-small homepage-bar" style="padding: 15px 7px 20px">
    <div class="col-lg-6 col-md-6 text-left">
      <div style="float: right">
        <P class="float-right">
          <span title="Número de Habilitados" class="display-block">
            <i class="fa fa-users" aria-hidden="true"></i>
            <span>{{ leilao.nu_qtdeliberados || 0 }}</span>
          </span>
          <span title="Quantidade de lotes" class="display-block">
            <i class="fa fa-tags" aria-hidden="true"></i>
            <span>{{ leilao.nu_qtdelotes || 0 }}</span>
          </span>
          <span title="Número de visitas" class="display-block">
             <i aria-hidden="true" class="fa fa-eye"></i>
            <span>{{ leilao.nu_qtdevisitas || 0 }}</span>
          </span>
        </P>
      </div>
      <div class="clearfix"></div>
      <h2 class="mb-0" :style="lotes ? `margin-top: -25px;` : ''">
        <strong>Leilão {{ leilao.id }}:</strong>
        <span id="status_montagem_span" :class="montagembg">{{
            montagem
          }}</span>
        <span id="status_leilao_span" :class="statusLeilaoBg">{{
            leilao.nm_status
          }}</span>
      </h2>
      <br/>
      <h1 class="mb-0" style="font-size: 19px">
        <span class="heading-primary">{{ leilao.nm }}</span>
      </h1>
      <br/>
      <p v-html="leilao.nm_descricao"></p>
      <p v-if="this.leilao.statusleilao_id != 6 && this.leilao.statusleilao_id != 2" v-html="leilao.nm_local"></p>
      <br/>
    </div>

    <div class="col-lg-6 col-md-6">
      <div class="col-lg-12 col-md-6 text-center">
        <div>
          <br/>
          <p><strong>COMPARTILHE</strong></p>
          <leilao-social
            :title="leilao.nm"
            :description="leilao.nm_descricao"
            :url="getLink()"
          />
        </div>
      </div>

      <div class="col-lg-12 col-md-4 text-center text-with-icons">
        <div v-if="leilao.anexos && leilao.anexos.length > 0">
          <a
            @click="opAnexos"
            class="d-inline-block doc-icons"
            target="_blank"
            style="text-decoration: underline; color: blue"
            title="Anexos"
          >
            <i class="fa fa-paperclip"></i>
            <span>Anexos</span>
          </a>
          <div
            id="dialog-anexo-leilao"
            title="Anexos para Download"
            style="display: none"
          >
            <ul class="list-arquivos" style="list-style: none">
              <li v-for="(anx, idx) in leilao.anexos[0]" :key="idx">
                <a
                  :href="`${leiloeiro.dominio_imagens}/anexo/${anx.nm_path}`"
                  target="_blank"
                  title="Download"
                >
                  <strong>{{ anx.nm_path }}</strong>
                  - {{ anx.nm }}
                </a>
              </li>
            </ul>
          </div>
          <div v-for="(anx, idx) in leilao.anexos" :key="idx">
            <div v-show="anx.statusanexo_id == 2">
              <a
                :href="`${leiloeiro.dominio_imagens}/anexo/${anx.nm_path}`"
                class="d-inline-block doc-icons"
                target="_blank"
                title="Edital"
              >
                <i class="fa fa-file-text"></i>
                <span>LEIA O EDITAL</span>
              </a>
            </div>
          </div>
        </div>
        <div>
          <a
            @click="opCondicoes"
            class="d-inline-block doc-icons"
            title="Condições de venda"
          >
            <i class="fa fa-arrow-circle-o-down"></i>
            <span>Condições de venda</span>
          </a>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>

import LeilaoSocial from "@/components/shared/social/LeilaoSocial.vue";

export default {
  name: "HeaderDisputa",
  components: {LeilaoSocial},
  props: ["leilaoid", "lotes", "loteid", "loadingRefresh", "lote", "dadosLeilao", "dadosModeradorId"],
  data() {
    return {
      firstLoad: true,
      leilao: [],
      leilao_id: this.$route.params.id,
      leiloeiro: [],
      dados_condicao: [],
      usuario: [],
      montagem: null,
      montagembg: null,
      statusLeilao: null,
      statusLeilaoBg: null,
      message: "",
      liberado: false,
      informativo: false,
      message_informativo: "",
      nu_liberados: null,
      datas: [],
      leilaoModerador: 0,
      dadosleilaoCarregamento: []
    };
  },
  watch: {
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
      if (this.leilao) {
        this.statusMontagem(this.leilao.statusmontagem_id);
        this.statusLeilaoChange(this.leilao.statusleilao_id);
      }
      if (!novo) this.msgEncerrado()
    },
    'dadosModeradorId'(novo, ant) {
      this.leilaoModerador = this.dadosModeradorId || 0
      this.dadosleilaoCarregamento = novo.items[0]

      if ([6, 8].includes(this.dadosleilaoCarregamento.statusmontagem_id) || this.leilaoModerador && this.leilaoModerador.leilao_id_segundoleilao > 0) {
        this.msgEncerrado()
        this.statusMontagem(this.dadosleilaoCarregamento.statusmontagem_id);
        this.statusLeilaoChange(this.dadosleilaoCarregamento.statusleilao_id);
      }
    },
  },
  methods: {
    formatarDataHora(dataString) {
      if (!dataString || typeof dataString !== 'string') {
        return '';
      }

      const data = new Date(dataString);
      if (isNaN(data.getTime())) {
        return '';
      }

      const dia = ('0' + data.getDate()).slice(-2);
      const mes = ('0' + (data.getMonth() + 1)).slice(-2);
      const ano = data.getFullYear();
      const hora = ('0' + data.getHours()).slice(-2);
      const minutos = ('0' + data.getMinutes()).slice(-2);
      return `${dia}/${mes}/${ano} ${hora}:${minutos}`;
    },
    opCondicoes(ev) {
      // CONDIÇÕES DE VENDA ONCLICK
      const hostName = location.protocol + "//" + window.HOSTNAME;

      openCondicoes(
        `${hostName}/leilao/condicoesdevenda?leilao_id=${this.leilao_id}`
      );

      const dialogButtonClose = document.querySelector('.ui-dialog-titlebar-close');
      if (dialogButtonClose) {
        dialogButtonClose.innerHTML = '&times;';
        dialogButtonClose.setAttribute('title', 'Fechar');
        dialogButtonClose.style.display = 'flex';
        dialogButtonClose.style.justifyContent = 'center';
        dialogButtonClose.style.alignItems = 'center';
      }

    },
    opAnexos(ev) {
      if (this.firstLoad) {
        $("#dialog-anexo-leilao").dialog({
          autoOpen: false,
          width: 600,
          modal: true,
          closeOnEscape: true,
          buttons: {
            Fechar: function () {
              $(this).dialog("close");
            },
          },
          open: function () {
            $(".ui-dialog-titlebar-close").hide();
          },
        });
        this.firstLoad = false;
      }
      $("#dialog-anexo-leilao").dialog("open");
    },
    statusMontagem(status) {
      switch (Number(status)) {
        case 1:
          this.montagem = "Em Loteamento - Não liberado";
          this.montagembg = "status-amarelo";
          break;
        case 2:
          this.montagem = "Listagem Parcial";
          this.montagembg = "status-amarelo";
          break;
        case 3:
          this.montagem = "Aberto para Lances";
          this.montagembg = "status-amarelo";
          break;
        case 7:
          this.montagem = "Em Loteamento - Sem data oficial";
          this.montagembg = "status-amarelo";
          break;
        case 4:
          this.montagem = "Cancelado";
          this.montagembg = "status-vermelho";
          break;
        case 5:
          this.montagem = "Suspenso";
          this.montagembg = "status-vermelho";
          break;
        case 6:
          this.montagem = "Finalizado";
          this.montagembg = "status-vermelho";
          break;
        case 9:
          this.montagem = "Em Breve";
          this.montagembg = "online-nm-status";
          break;
        case 8:
          this.montagem = "Finalizado - Não divulgado";
          this.montagembg = "status-vermelho";
          break;
      }
    },
    statusLeilaoChange(status) {
      switch (Number(status)) {
        case 8:
        case 10:
        case 9:
          this.statusLeilao = "Físico";
          this.statusLeilaoBg = "fisico-nm-status";
          break;
        case 6:
        case 2:
        case 19:
          this.statusLeilao = "Online";
          this.statusLeilaoBg = "online-nm-status";
          break;
        case 1:
        case 3:
          this.statusLeilao = "Presencial";
          this.statusLeilaoBg = "presencial-nm-status";
          break;
        case 12:
        case 11:
        case 7:
        case 5:
          this.statusLeilao = "Justiça";
          this.statusLeilaoBg = "justica-nm-status";
          break;
      }
    },
    loadMsg() {
      var exibe_usuario_id = false;
      // VERIFICA STATUS MENSAGEM
      const tipoMsg = [
        {1: "Leilão presencial sem participação online."},
        {5: "Leilão suspenso"}
      ];

      tipoMsg.forEach(msgObj => {
        const statusId = Object.keys(msgObj)[0]; // Extrai o statusmontagem_id
        const message = msgObj[statusId]; // Extrai a mensagem correspondente

        if (this.dadosleilaoCarregamento.statusmontagem_id == statusId) {
          this.message = message;
          return;
        }
      });
      if (this.usuario.id !== null) {
        exibe_usuario_id = true;
        if (this.usuario.statusliberacaoonline_id !== 3) {
          this.message = this.usuario.nm_statusliberacaomensagem;
        } else if (this.dados_condicao.aceitou_condicao == false) {
          this.message = `
                <a style="margin-left: 10px;" title="Condições de Venda" href="javascript:void(0)" onclick="openCondicoes('/leilao/condicoesdevenda?leilao_id=${this.leilao_id}');">
                    Clique aqui para aceitar as condições de venda.
                </a>
            `;
        } else {
          this.message = this.usuario.nm_statusliberacaomensagem;
        }
      } else {
        this.message = `
            <a href="/index/login" style="color: white">Usuário não logado, para iniciar os lances é preciso estar logado. Clique aqui para fazer login.</a>
        `;
      }

      if (this.leilao.bn_ocultaapelido == 1) {
        this.message_informativo = "Para este tipo de leilão o seu apelido ficará oculto.";
        if (exibe_usuario_id == true) {
          this.message_informativo += " Seu código de identificação é: " + this.usuario.id;
        } else {
          this.message_informativo += " Ao efetuar login, seu código de identificação aparecerá aqui!";
        }
        this.informativo = true;
      }

      this.msgEncerrado();
    },

    msgEncerrado() {
      const self = this;
      let message = '';
      let baseUrl = '/';

      if ([6, 8].includes(this.dadosleilaoCarregamento.statusmontagem_id) && self.leilaoModerador.leilao_id_segundoleilao > 0) {
        message = `
         <a href="${baseUrl}leilao/index/leilao_id/${self.leilaoModerador.leilao_id_segundoleilao}">
            Este leilão já se encerrou, clique aqui para acessar o segundo leilão.
         </a>
         `;
        self.$parent.$emit("liberacaoMensagem", {
          liberado: self.leilaoModerador.aceitou_condicao,
          message: '',
          informativo: true,
          message_informativo: message,
          fechamento: self.leilao.bn_fechamentoautomatico,
          leilaoId: self.leilaoId,
          mostrarMesagem: true
        });
        return;
      }

      if (self.leilao !== undefined && [6, 8].includes(this.dadosleilaoCarregamento.statusmontagem_id)) {
        message = `
            <a href="${baseUrl}">
             Este leilão já se encerrou ou foi removido, clique aqui para voltar ao início.
            </a>
          `;
      }

      if (self.leilao !== undefined && self.leilao.leilao_id_primeiroleilao > 0 && [6, 8].includes(this.dadosleilaoCarregamento.statusmontagem_id)
        || (self.leilao !== undefined && self.leilao.dt_segundoleilao_data === null && [6, 8].includes(this.dadosleilaoCarregamento.statusmontagem_id))
      ) {
        message = `
            <a href="${baseUrl}">
             Este leilão já se encerrou, clique aqui para voltar ao início.
            </a>
          `;
      }

      if (self.leilao === undefined) {
        message = `
            <a href="${baseUrl}">
              Este leilão já se encerrou ou foi removido, clique aqui para voltar ao início.
            </a>
          `;
      }

      if (message) {
        self.$parent.$emit("liberacaoMensagem", {
          liberado: self.leilaoModerador.aceitou_condicao,
          message: '',
          informativo: true,
          message_informativo: message,
          fechamento: self.leilao.bn_fechamentoautomatico,
          leilaoId: self.leilaoId,
          mostrarMesagem: true
        });
      }
    },

    getLink() {
      return window.location.href
    },

    verificaRota() {
      const rotaComLote = `leilao_id=${this.leilaoid}&lote_id=${this.loteid}`;
      const rotaSemLote = `leilao_id=${this.leilao_id}`;

      if (this.loteid === undefined) {
        return rotaSemLote;
      } else if (this.loteid) {
        return rotaComLote;
      }
    },

    async showLeilao() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const rota = this.verificaRota();

      const headers = {
        'Content-Type': 'application/json' // Inclua outros headers necessários
      };

      const token = window.localStorage.getItem('token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      try {
        const response = await fetch(`${hostName}/leilao/get-dados-header-disputa?${rota}`, {headers});

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const res = await response.json();

        this.leiloeiro = res.config_leiloeiro;
        this.dados_condicao = res.dados_condicao;
        this.usuario = res.usuario;

        // Usuário com preferência.
        window.localStorage.setItem('a5cc51388b67c5c132389a6ffc950dbf', JSON.stringify(res.usuario_preferencia));
        await this.loadMsg();

        this.$parent.$emit("dados-gerais", {
          config_leiloeiro: this.leiloeiro,
          dados_condicao: this.dados_condicao,
          usuario: this.usuario,
          vl_lanceautomatico: res.vl_lanceautomatico,
          navegacao: res.navegacao,
          thisHeaderDisputa: this,
          visitas: res.visitas,
        });

        this.$parent.$emit("liberacaoMensagem", {
          liberado: res.dados_condicao.aceitou_condicao,
          message: this.message,
          informativo: this.informativo,
          message_informativo: this.message_informativo,
          fechamento: this.leilao.bn_fechamentoautomatico,
          leilaoId: this.leilaoid,
          mostrarMesagem: true
        });

        sessionStorage.setItem("isLogado", this.usuario.id !== null ? "true" : "false");

      } catch (error) {
        console.error("Erro ao carregar dados do leilão:", error);
      }
    }
  },
  async created() {
    await this.showLeilao()
    this.leilao = this.dadosLeilao

    if (this.leilao) {
      this.statusMontagem(this.leilao.statusmontagem_id);
      this.statusLeilaoChange(this.leilao.statusleilao_id);
    }

    this.leilaoModerador = this.dadosModeradorId || 0
    this.$parent.$on('statusloteClicado', () => this.showLeilao())
  },
};
</script>
<style scoped>
span.data_um_dois {
  display: flex;
  flex-direction: row;
}

span.data_um_dois span {
  margin-right: 3px;
}

.text-with-icons a {
  text-decoration: none !important;
}

.text-with-icons span {
  font-size: 12px;
  display: block;
}

.list-arquivos li {
  border-bottom: 2px solid #555;
}

#status_montagem_span,
#status_leilao_span {
  padding: 5px;
  border-radius: 3px;
}

.status-vermelho {
  background: #e47211 !important;
  color: #fff !important;
}

.status-amarelo {
  background: #efbb00 !important;
}

/* categoria leilao */
.fisico-nm-status {
  background: #118ce4 !important;
  color: #fff !important;
}

.online-nm-status {
  background: #91bc1f !important;
}

.presencial-nm-status {
  background: #692f2b !important;
  color: #fff !important;
}

.justica-nm-status,
.status-vermelho {
  background: #e47211 !important;
  color: #fff !important;
}

p {
  color: #000 !important;
}

@media (max-width: 508px) {
  #status_montagem_span,
  #status_leilao_span {
    display: block;
  }

  #portotemplate a.doc-icons {
    width: 97%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/HeaderDisputa.vue